export const start = async () => {
  if (typeof window !== "undefined") {
    const { worker } = require("./browser");
    await worker.start({
      serviceWorker: {
        url: "/mockServiceWorker.v2.js",
      },
    });
  }
};
